import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=341291a0"
import script from "./ShiftReport.vue?vue&type=script&lang=ts"
export * from "./ShiftReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports